module.exports = __webpack_public_path__ + "static/banner-dc81ee70bdd6eb5950ff37b434ba2a75.jpg";